<template>
    <teleport to="#teleport-modal">
        <div id="modal-bg" class="fixed z-10 inset-0 overflow-hidden bg-black bg-opacity-25 flex justify-center backdrop-blur-sm mx-0 md:mx-auto py-10"
        v-if="this.$store.state.filter.showModal"
        >
            <div ref="theModal" class="bg-white rounded-xl w-3/4 my-auto relative">
                <button class="absolute top-2 right-2 text-gray-500 hover:text-gray-700" @click="this.$store.commit('filter/setShowModal',false)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <div class="pl-5 pt-3 font-bold">Filters</div>
                <div class="mx-5 my-3">
                    <BaseFilterCategory/>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>

import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { useStore } from 'vuex'
import BaseFilterCategory from './BaseFilterCategory.vue';
import BorderLine from './BorderLine.vue';

export default {
        setup(){
            const theModal = ref(null)
            const store = useStore()
            onClickOutside(theModal, () => {
                console.log('clicked outside')
                store.commit('filter/setShowModal', false)
            })
            return { theModal }
        },

    name: "FilterModal",
    components: { BaseFilterCategory,BorderLine },
    data(){
        return{
            show: false
        }
    }


    }
</script>
